import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { Problem } from './components/sections/Problem';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { Pathway } from './components/sections/Pathway';
import { Volumes } from './components/sections/Volumes';
import { Bonuses } from './components/sections/Bonuses';
import { Walkthrough } from './components/sections/Walkthrough';
import { Testimonials } from './components/sections/Testimonials';
import { Audience } from './components/sections/Audience';
import { Author } from './components/sections/Author';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Faq } from './components/sections/Faq';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-ink font-sans text-body" data-id="element-0" data-mp="3mljat0fdtn5p">
      <MetaPixel data-id="element-1" data-mp="3mj6ipufwtwex" />
      <Hero data-id="element-2" data-mp="3rcj5s04xxv5k" />
      <main data-id="element-3" data-mp="3rbrbqtqzs5he">
        <Problem data-id="element-4" data-mp="3rdaquh0wwahl" />
        <BeforeAfter data-id="element-5" data-mp="3rcsy3udgkeef" />
        <Pathway data-id="element-6" data-mp="3recdlirailf5" />
        <Volumes data-id="element-7" data-mp="5yi8qe3h5da" />
        <Bonuses data-id="element-8" data-mp="6hovayao7c0" />
        <Walkthrough data-id="element-9" data-mp="4wx1t3d72hu" />
        <Testimonials data-id="element-10" data-mp="5gbgztt38r4" />
        <Audience data-id="element-11" data-mp="7ssnarqpf34" />
        <Author data-id="element-12" data-mp="2zld2jatxbhc2" />
        <Offer data-id="element-13" data-mp="2zlv84y2h77wn" />
        <Guarantee data-id="element-14" data-mp="2zmeowbge3q93" />
        <Faq data-id="element-15" data-mp="2zmwguvw0rib7" />
        <FinalCta data-id="element-16" data-mp="2zng1ikd20ksx" />
      </main>
      <Footer data-id="element-17" data-mp="33m5a7zn5de68" />
      <FloatingCta data-id="element-18" data-mp="33nq6btp41567" />
      <PurchasePopup data-id="element-19" data-mp="33n6yx6x35z6f" />
    </div>;
}